export const getPlaceholderTextFromLabel = (label: string) => {
  if (!label) return ''
  const labelWithoutColon = label.replace(/:$/, '')
  return `Enter ${labelWithoutColon}`
}
